import {
  SET_MISSIONS,
  SET_MISSION,
  SET_MISSION_LOADING,
  SET_MISSION_META_GROUPS,
  SET_MISSION_IC_NOT_READY,
  PUSH_MISSION_META_GROUPS_DISABLED,
  REMOVE_MISSION_META_GROUPS_DISABLED,
} from './mutation-types';

export default {
  /**
   * Update mission
   * @param {object} state - the vuex state object
   * @param {object} payload - the complete mission object
   */
  [SET_MISSIONS](state, payload) {
    state.missions = payload;
  },
  /**
   * Update mission
   * @param {object} state - the vuex state object
   * @param {object} payload - the complete mission object
   */
  [SET_MISSION](state, payload) {
    state.mission = payload;
  },
  /**
   * Load mission
   * @param {object} state - the vuex state object
   * @param {boolean} payload - boolean
   */
  [SET_MISSION_LOADING](state, payload) {
    state.missionLoading = payload;
  },

  /**
   * Set mission meta groups
   * @param {object} state - the vuex state object
   * @param {boolean} payload - Array of meta groups
   */
  [SET_MISSION_META_GROUPS](state, payload) {
    state.missionMetaGroups = payload;
  },

  /**
   *
   * @param state
   * @param payload
   */
  [PUSH_MISSION_META_GROUPS_DISABLED](state, { meta }) {
    state.missionMetaGroupsDisabled.push(meta);
  },

  /**
   *
   * @param state
   * @param payload
   */
  [REMOVE_MISSION_META_GROUPS_DISABLED](state, { list, meta }) {
    const metaList = list.filter((metaG) => metaG?.name !== meta?.name);
    state.missionMetaGroupsDisabled = metaList;
  },

  /**
   * Set mission meta groups
   * @param {object} state - the vuex state object
   * @param {boolean} payload - Array of meta groups
   */
  [SET_MISSION_IC_NOT_READY](state, payload) {
    state.missionICNotReady = payload;
  },

};
